import React, { useState, useEffect, useCallback } from 'react';

import {
  Box, Card, Grid, TextField, Typography, Container, Tooltip, CardContent, IconButton, Avatar, Dialog, DialogContent,
  DialogTitle, FormControl, FormHelperText, Button, Select, InputLabel, MenuItem, useMediaQuery, useTheme
} from '@mui/material';
import TagIcon from '@mui/icons-material/Tag';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import CategoryIcon from '@mui/icons-material/Category'; // For Category
import InventoryIcon from '@mui/icons-material/Inventory'; // For Stock
import NumbersIcon from '@mui/icons-material/Numbers'; // For Quantity
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close'; // For Status
import StyleIcon from '@mui/icons-material/Style'; // For Type/Size
import BorderColorIcon from '@mui/icons-material/BorderColor';
import EditOffIcon from '@mui/icons-material/EditOff';
import { CircularProgress } from '@mui/material';
import HttpsIcon from '@mui/icons-material/Https';

import Swal from 'sweetalert2';
import { message } from 'antd';

import '../../../Styles/Interface/Inventory/InventoryItems.css'; // Import your CSS file

function InventoryItems() {
  const [response, setResponse] = useState([]);
  const [items, setItems] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [permissionError, setPermissionError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [services, setServices] = useState([]);

  const checkPermissions = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      messageApi.error('No se encontró el token de autenticación.');
      setPermissionError(true);
      window.location.href = '/sign-in'; // Redirect to login if no token
      return;
    }
    setPermissionError(false);
    setIsLoading(true);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/users/check-modify-role-permissions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.status === 403) {
        messageApi.error('No tienes permisos para acceder a esta sección.');
        setPermissionError(true);
        throw new Error('No tienes permisos para acceder a esta sección.');
      }
    } catch (error) {
      messageApi.error(error.message || 'Error al verificar permisos.');
      throw error; // Re-throw to handle it in the calling function
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  // Responsive
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery('(max-width:480px)');

  const token = localStorage.getItem('token');

  // Function to fetch items from the API
  const fetchItems = async () => {
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/inventory/list-clothes', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        return messageApi.error({
          content: 'No se pudieron cargar los artículos, por favor recargue la pagina.',
          className: 'custom-class',
          duration: 2,
          style: {
            marginTop: '20vh',
          }
        });
      }
      const data = await response.json();
      setResponse(data);
      setItems(data);
    } catch (err) {
      messageApi.error({
        content: 'No se pudieron cargar los artículos, por favor recargue la pagina.',
        className: 'custom-class',
        duration: 2,
        style: {
          marginTop: '20vh',
        }
      });
    }
  }

  // Function to fetch services from the API
  const getServices = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch('https://d-princess.ddns.net/services/clothes', {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (!data.error) {
        setServices(data);
      }
    } catch (error) {
      console.error('Error:', error);
      messageApi.error('Error al obtener servicios.');
    }
  };

  // Function to handle edit button click (to open the dialog)
  const handleEditClick = (item) => {
    setFormData(item);
    setOpen(true);
  };

  // Function to handle close Dialog
  const handleClose = () => {
    setOpen(false);
    setFormData({});
  };

  // Function to handle form data change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Function to handle form submission (to save changes)
  const handleFormSubmit = async () => {
    try {
      const confirmation = await Swal.fire({
        title: '¿Está seguro de que desea guardar los cambios?',
        text: "¡No podrá deshacer esta acción!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, guardar cambios',
        cancelButtonText: 'Cancelar'
      });
      if (confirmation.isConfirmed) {
        setOpen(false);
        try {
          Swal.fire({
            title: 'Guardando cambios...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          const response = await fetch(`https://dprincess-training.servehttp.com/inventory/update-clothes/${formData.itemID}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(formData),
          });
          if (!response.ok) {
            return Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudieron guardar los cambios.',
            }).then(() => {
              setOpen(true);
            });
          }
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: 'Los cambios se han guardado correctamente.',
          }).then(() => {
            fetchItems();
            setOpen(true);
          });

        } catch (error) {
          console.error('Error al guardar los cambios:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron guardar los cambios.',
          }).then(() => {
            setOpen(true);
          });
        }
      }
    } catch (error) {
      messageApi.error({
        content: 'Error al guardar los cambios.',
        className: 'custom-class',
        duration: 2,
        style: {
          marginTop: '20vh',
        }
      }).then(() => {
        setOpen(true);
      });
    }
  }

  // Function to handle search input change
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // Function to handle applying filters by category
  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setCategory(selectedCategory);
  }

  // Function to filter items based on search and category
  const applyFilters = useCallback(() => {
    let filteredItems = [...response]; // Create a copy of the response array

    // Apply category filter if selected
    if (category && category !== "") {
      filteredItems = filteredItems.filter((item) => item.itemCategory === category);
    }

    // Apply search filter if search term exists
    if (search && search.trim() !== "") {
      const lowerCaseSearch = search.toLowerCase();
      filteredItems = filteredItems.filter((item) => {
        return (
          item.itemName.toLowerCase().includes(lowerCaseSearch) ||
          item.code.toLowerCase().includes(lowerCaseSearch)
        );
      });
    }
    setItems(filteredItems); // Update the displayed list
  }, [response, search, category]);

  useEffect(() => {
    getServices();
    fetchItems();
  }, []);

  useEffect(() => {
    if (response.length > 0) {
      applyFilters();
    }
    else {
      setItems([]);
    }
  }, [search, response, applyFilters]);

  const categoryMap = {
    12: 'xv',
    22: 'wedding',
    35: 'men',
    36: 'child',
    13: 'personal',
    14: 'girls'
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (permissionError) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: '#f44336', width: 64, height: 64 }}>
            {/* Icono de candado para indicar acceso restringido */}
            <HttpsIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: '#f44336', fontWeight: 700 }}>
            No tienes permiso para acceder a esta sección
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'center' }}>
            Esta información solo está disponible para usuarios con permisos de administrador.
          </Typography>
        </Box>
      </Container>
    );
  };

  return (
    <Container sx={{
      padding: { xs: '1rem', md: '2rem' },
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: { xs: '100%', md: 'lg' }
    }}>
      {/* Message API for displaying messages */}
      {contextHolder}
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Title and Card for displaying items */}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          padding: { xs: '0.5rem', md: '1rem' },
          justifyContent: 'center'
        }}>
          <Container sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            backgroundColor: '#f759ab',
            padding: { xs: '0.25rem', md: '0.5rem' },
            borderRadius: '8px 8px 0 0',
            marginBottom: '0.5rem'
          }}>
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
                color: 'white',
                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.7rem' },
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              Artículos en Inventario
            </Typography>
          </Container>
          {/* Filters and search */}
          <Grid container spacing={{ xs: 1, md: 2 }} sx={{
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <Grid item xs={12} md={4}>
              <TextField
                label="Buscar por nombre o código"
                variant="outlined"
                fullWidth
                size={isMobile ? "small" : "medium"}
                onChange={(e) => handleSearchChange(e)}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 1, md: 2 }
            }}>
              <Typography
                variant={isMobile ? "h6" : "h5"}
                sx={{
                  fontSize: { xs: '1.5rem', md: '3rem' },
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 'auto'
                }}
              >
                <CategoryIcon fontSize="inherit" sx={{ color: '#531dab' }} />
              </Typography>
              <FormControl fullWidth variant="outlined" size={isMobile ? "small" : "medium"}>
                <InputLabel id="category-filter-label">Categoría</InputLabel>
                <Select
                  labelId="category-filter-label"
                  label="Categoría"
                  value={category}
                  onChange={handleCategoryChange}
                >
                  <MenuItem value="">Todos</MenuItem>
                  {services.map((service) => {
                    const cat = categoryMap[Number(service.serviceID)];
                    if (cat) {
                      return <MenuItem key={service.serviceID} value={cat}>{service.serviceName}</MenuItem>;
                    }
                    return null;
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Card sx={{
          padding: { xs: '0.5rem', md: '1rem' },
          backgroundColor: '#f5f5f5',
          width: '100%'
        }} variant='outlined'>
          {/* Card Header */}
          <CardContent sx={{ padding: { xs: '0.5rem', md: '1rem' } }}>
            {items?.length > 0 && items.map((item) => (
              item.itemName !== 'No aplica' && (
                <Card sx={{
                  marginTop: { xs: 0.5, md: 1 },
                  width: '100%',
                  boxShadow: { xs: '0 1px 3px rgba(0,0,0,0.1)', md: '0 2px 4px rgba(0,0,0,0.1)' }
                }} variant="outlined" key={item.id}>
                  <CardContent sx={{ padding: { xs: '0.75rem', md: '1rem' } }}>
                    {/* Title Row */}
                    <Grid container spacing={{ xs: 1, md: 2 }}>
                      <Grid item xs={isMobile ? 10 : 6}>
                        <Typography
                          variant={isMobile ? "subtitle1" : "h6"}
                          sx={{
                            marginBottom: { xs: '0.5rem', md: '1rem' },
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '1rem', md: '1.25rem' },
                            lineHeight: 1.3
                          }}
                        >
                          <CheckroomIcon sx={{
                            color: item.itemType === 'dress' ? '#f759ab' : '#1976d2',
                            fontSize: { xs: '1.2rem', md: '1.5rem' }
                          }} />
                          {item.itemType === 'dress' ? `Vestido ${item.itemName}` : `${item.itemName}`}
                        </Typography>
                      </Grid>
                      {/* Edit button */}
                      <Grid item xs={isMobile ? 2 : 6} sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: isMobile ? 'flex-start' : 'center'
                      }}>
                        <IconButton
                          onClick={() => handleEditClick(item)}
                          size={isMobile ? "small" : "medium"}
                        >
                          <Tooltip title="Editar" arrow placement="top">
                            <Avatar sx={{
                              backgroundColor: 'primary.main',
                              color: 'white',
                              width: { xs: 32, md: 40 },
                              height: { xs: 32, md: 40 }
                            }}>
                              <BorderColorIcon sx={{
                                color: 'white',
                                fontSize: { xs: '1rem', md: '1.25rem' }
                              }} />
                            </Avatar>
                          </Tooltip>
                        </IconButton>
                      </Grid>
                    </Grid>
                    {/* Code & Category Row */}
                    <Grid container spacing={{ xs: 1, md: 2 }} sx={{
                      marginBottom: { xs: '0.5rem', md: '1rem' }
                    }}>
                      {/* Dress code */}
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '0.875rem', md: '1rem' }
                          }}
                        >
                          <TagIcon fontSize="inherit" sx={{ color: 'primary.secondary' }} />
                          Código: {item.code}
                        </Typography>
                      </Grid>
                      {/* Category */}
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '0.875rem', md: '1rem' }
                          }}
                        >
                          <CategoryIcon fontSize="inherit" sx={{ color: 'secondary.main' }} />
                          Categoría: {' '}
                          {
                            item.itemCategory === 'xv' ? 'Quinceaños' :
                            item.itemCategory === 'wedding' ? 'Boda' :
                            item.itemCategory === 'girls' ? 'Vestido de niña' :
                            item.itemCategory === 'personal' ? 'Vestido de dama' :
                            item.itemCategory === 'child' ? 'Traje de niño' :
                            item.itemCategory === 'men' ? 'Traje de hombre' :
                            item.itemCategory === 'other' ? 'Otros' : item.itemCategory
                          }
                        </Typography>
                      </Grid>
                    </Grid>
                    {/* Stock & Quantity Row */}
                    <Grid container spacing={{ xs: 1, md: 2 }} sx={{
                      marginBottom: { xs: '0.5rem', md: '1rem' }
                    }}>
                      {/* Inventory */}
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '0.875rem', md: '1rem' }
                          }}
                        >
                          <InventoryIcon
                            fontSize="small"
                            sx={{
                              color: item.stock === 'disponible' ? 'green' : 'orange',
                              fontSize: { xs: '1rem', md: '1.25rem' }
                            }}
                          />
                          Inventario: {item.stock.charAt(0).toUpperCase() + item.stock.slice(1)}
                        </Typography>
                      </Grid>
                      {/* Quantity */}
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '0.875rem', md: '1rem' }
                          }}
                        >
                          <NumbersIcon
                            fontSize="small"
                            sx={{
                              color: 'text.secondary',
                              fontSize: { xs: '1rem', md: '1.25rem' }
                            }}
                          />
                          Cantidad: {item.quantity}
                        </Typography>
                      </Grid>
                    </Grid>
                    {/* Status & Type Row */}
                    <Grid container spacing={{ xs: 1, md: 2 }} sx={{
                      marginBottom: { xs: '0.5rem', md: '1rem' }
                    }}>
                      {/* Status */}
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '0.875rem', md: '1rem' }
                          }}
                        >
                          <InfoIcon
                            fontSize="small"
                            sx={{
                              color: item.status === 'activo' ? 'success.main' : 'warning.main',
                              fontSize: { xs: '1rem', md: '1.25rem' }
                            }}
                          />
                          Estado: {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                        </Typography>
                      </Grid>
                      {/* Type/Size */}
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: { xs: '0.875rem', md: '1rem' }
                          }}
                        >
                          <StyleIcon
                            fontSize="small"
                            sx={{
                              color: 'secondary',
                              fontSize: { xs: '1rem', md: '1.25rem' }
                            }}
                          />
                          Tipo: {item.size === 'short' ? 'Vestido corto' :
                            item.size === 'long' ? 'Vestido largo' :
                              item.size === 'medium' ? 'Traje mediano' :
                                item.size === 'large' ? 'Traje grande' :
                                  item.size === 'small' ? 'Traje pequeño' :
                                    item.size === 'xl' ? 'Traje extra grande' :
                                      item.size === 'xxl' ? 'Traje doble extra grande' :
                                        `Talla ${item.size}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              )
            ))}
          </CardContent>
        </Card>
      </Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        sx={{
          '& .MuiDialog-paper': {
            margin: { xs: 0, md: '32px' },
            maxHeight: { xs: '100%', md: 'calc(100% - 64px)' },
            borderRadius: { xs: 0, md: '8px' }
          }
        }}
      >
        <Container sx={{
          padding: { xs: '0.25rem', md: '0.4rem' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: '#f759ab'
        }}>
          <DialogTitle sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: 'white',
            fontSize: { xs: '1.5rem', md: '2.5rem' },
            padding: { xs: '0.5rem', md: '1rem' }
          }}>
            Editar Artículo
          </DialogTitle>
          {isMobile && (
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpen(false)}
              sx={{ color: 'white', marginLeft: 'auto' }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Container>
        <DialogContent sx={{
          padding: { xs: '1rem', md: '1.5rem' },
          '&:first-of-type': { paddingTop: { xs: '1rem', md: '1.5rem' } }
        }}>
          {/* Form to edit item goes here */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <TextField
              name="itemName"
              label="Nombre del Articulo"
              variant="outlined"
              value={formData?.itemName}
              onChange={handleFormChange}
              error={false} // Replace with validation logic
              size={isMobile ? "small" : "medium"}
            />
            <FormHelperText>Campo requerido</FormHelperText>
          </FormControl>
          <Grid container spacing={{ xs: 1, md: 2 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal">
                <TextField
                  name="code"
                  label="Código"
                  variant="outlined"
                  value={formData?.code || ''}
                  onChange={handleFormChange}
                  error={false} // Replace with validation logic
                  size={isMobile ? "small" : "medium"}
                />
                <FormHelperText>Campo requerido</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin='normal'>
                <InputLabel id="item-category-label">Categoría</InputLabel>
                <Select
                  labelId='item-category-label'
                  label="Categoría"
                  value={formData?.itemCategory || ''}
                  onChange={handleFormChange}
                  name="itemCategory"
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                >
                  {services.map((service) => {
                    const cat = categoryMap[Number(service.serviceID)];
                    if (cat) {
                      return <MenuItem key={service.serviceID} value={cat} disabled={
                        (cat === 'xv' || cat === 'wedding' || cat === 'personal' || cat === 'girls') && formData.itemType === 'suit' ||
                        (cat === 'men' || cat === 'child') && formData.itemType === 'dress'
                      }>{service.serviceName}</MenuItem>;
                    }
                    return null;
                  })}
                </Select>
                <FormHelperText>Campo requerido</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={{ xs: 1, md: 2 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal">
                <InputLabel id="item-inventory-label">Inventario</InputLabel>
                <Select
                  labelId='item-inventory-label'
                  label="Inventario"
                  value={formData?.stock || 'disponible'}
                  onChange={handleFormChange}
                  name="stock"
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                >
                  <MenuItem value="disponible">Disponible</MenuItem>
                  <MenuItem value="pendiente">Pendiente</MenuItem>
                  <MenuItem value="sinExistencia">Sin existencia</MenuItem>
                </Select>
                <FormHelperText>Campo requerido</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal">
                <TextField
                  name="quantity"
                  label="Cantidad"
                  variant="outlined"
                  value={formData?.quantity || ''}
                  onChange={handleFormChange}
                  type="number"
                  error={false} // Replace with validation logic
                  size={isMobile ? "small" : "medium"}
                />
                <FormHelperText>Campo requerido</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={{ xs: 1, md: 2 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal">
                <InputLabel id="item-status-label">Estado</InputLabel>
                <Select
                  labelId='item-status-label'
                  label="Estado"
                  value={formData?.status || 'activo'}
                  onChange={handleFormChange}
                  name="status"
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                >
                  <MenuItem value="activo">Activo</MenuItem>
                  <MenuItem value="inactivo">Inactivo</MenuItem>
                </Select>
                <FormHelperText>Campo requerido</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal">
                {/* Size/Type selection */}
                {
                  formData?.itemCategory !== 'child' ? (
                    <>
                      <InputLabel id="item-type-label">Tipo/Talla</InputLabel>
                      <Select
                        labelId='item-type-label'
                        label="Tipo/Talla"
                        value={formData?.size || ''}
                        onChange={handleFormChange}
                        name="size"
                        fullWidth
                        size={isMobile ? "small" : "medium"}
                      >
                        <MenuItem value="short" disabled={formData.itemType === 'suit'}>Vestido corto</MenuItem>
                        <MenuItem value="long" disabled={formData.itemType === 'suit'}>Vestido largo</MenuItem>
                        <MenuItem value="medium" disabled={formData.itemType === 'dress'}>Traje mediano</MenuItem>
                        <MenuItem value="large" disabled={formData.itemType === 'dress'}>Traje grande</MenuItem>
                        <MenuItem value="small" disabled={formData.itemType === 'dress'}>Traje pequeño</MenuItem>
                        <MenuItem value="xl" disabled={formData.itemType === 'dress'}>Traje extra grande</MenuItem>
                        <MenuItem value="xxl" disabled={formData.itemType === 'dress'}>Traje doble extra grande</MenuItem>
                      </Select>
                    </>
                  ) : (
                    <TextField
                      label="Talla"
                      variant="outlined"
                      value={formData?.size || ''}
                      size={isMobile ? "small" : "medium"}
                      onChange={handleFormChange}
                      error={false} // Replace with validation logic
                      name="size"
                    />
                  )
                }
                <FormHelperText>Campo requerido</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <Box sx={{
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-end' },
          padding: { xs: '1rem', md: '1rem' },
          gap: { xs: 1, md: 0 },
          flexDirection: { xs: 'column', sm: 'row' }
        }}>
          <Button
            variant="outlined"
            color="error"
            onClick={handleClose}
            sx={{
              marginRight: { xs: 0, sm: '1rem' },
              marginBottom: { xs: '0.5rem', sm: 0 }
            }}
            startIcon={<EditOffIcon />}
            size={isMobile ? "small" : "medium"}
            fullWidth={isMobile}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleFormSubmit(formData)}
            startIcon={<BorderColorIcon />}
            size={isMobile ? "small" : "medium"}
            fullWidth={isMobile}
          >
            Guardar Cambios
          </Button>
        </Box>
      </Dialog>
    </Container>
  )
}

export default InventoryItems